import { Dispatch, bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TrainingEventModal from './TrainingEventModal';
import { createEventRequest, updateEventRequest } from '../../../../actions/calendar';
import State from '../../../../models';
import { fetchTeamRequest } from '../../../../actions/teams';

const mapStateToProps = (
  {
    teams,
    calendar: { loading, event },
    user: {
      user,
    },
  }: State,
) => ({
  loading,
  event,
  firstName: user ? user.firstName : null,
  teamsByHash: teams.byHash,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createEvent: bindActionCreators(createEventRequest, dispatch),
  updateEvent: bindActionCreators(updateEventRequest, dispatch),
  fetchTeam: bindActionCreators(fetchTeamRequest, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TrainingEventModal));
